import React, { useEffect, createElement } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
interface SEOProps {
  page?: string;
}
type Language = 'en' | 'ru' | 'ua' | 'pl';
interface PageMeta {
  title: string;
  description: string;
}
interface PageSEO {
  en: PageMeta;
  ru: PageMeta;
  ua: PageMeta;
  pl: PageMeta;
}
// SEO data
const getSeoData = (): Record<string, PageSEO> => ({
  home: {
    en: {
      title: 'IT Monsters | Professional Web Design & Development',
      description: 'IT Monsters is a professional IT studio. We design and develop websites of any complexity. Get a free demo in 1–3 days. Remote team, worldwide.'
    },
    ru: {
      title: 'IT Monsters | Профессиональная разработка сайтов',
      description: 'IT Monsters — профессиональная IT-студия. Создаем сайты любой сложности. Сначала делаем бесплатное демо (1–3 дня). Работаем онлайн по всему миру.'
    },
    ua: {
      title: 'IT Monsters | Професійна розробка сайтів',
      description: 'IT Monsters — професійна IT-студія. Створюємо сайти будь-якої складності. Спочатку робимо безкоштовне демо (1–3 дні). Працюємо онлайн по всьому світу.'
    },
    pl: {
      title: 'IT Monsters | Profesjonalne Tworzenie Stron Internetowych',
      description: 'IT Monsters to profesjonalne studio IT. Projektujemy i tworzymy strony o dowolnej złożoności. Zdobądź darmowe demo w 1-3 dni. Zespół zdalny, cały świat.'
    }
  },
  referral: {
    en: {
      title: 'Referral Program — Earn 430 zł per Referral | IT Monsters',
      description: 'Join IT Monsters referral program. Earn 430 zł for every successful referral. No limits on earnings. Fast payouts within 7 days.'
    },
    ru: {
      title: 'Реферальная программа — Зарабатывайте 430 zł за рекомендацию | IT Monsters',
      description: 'Присоединяйтесь к реферальной программе IT Monsters. Получайте 430 zł за каждого приведённого клиента. Без лимитов. Выплаты в течение 7 дней.'
    },
    ua: {
      title: 'Реферальна програма — Заробляйте 430 zł за рекомендацію | IT Monsters',
      description: 'Приєднуйтесь до реферальної програми IT Monsters. Отримуйте 430 zł за кожного приведеного клієнта. Без лімітів. Виплати протягом 7 днів.'
    },
    pl: {
      title: 'Program Partnerski — Zarabiaj 430 zł za Polecenie | IT Monsters',
      description: 'Dołącz do programu partnerskiego IT Monsters. Zarabiaj 430 zł za każde udane polecenie. Brak limitów zarobków. Szybkie wypłaty w ciągu 7 dni.'
    }
  },
  privacy: {
    en: {
      title: 'Privacy Policy | IT Monsters',
      description: 'IT Monsters Privacy Policy. Learn how we collect, use, and protect your personal data. GDPR compliant.'
    },
    ru: {
      title: 'Политика конфиденциальности | IT Monsters',
      description: 'Политика конфиденциальности IT Monsters. Узнайте, как мы собираем, используем и защищаем ваши персональные данные.'
    },
    ua: {
      title: 'Політика конфіденційності | IT Monsters',
      description: 'Політика конфіденційності IT Monsters. Дізнайтеся, як ми збираємо, використовуємо та захищаємо ваші персональні дані.'
    },
    pl: {
      title: 'Polityka Prywatności | IT Monsters',
      description: 'Polityka Prywatności IT Monsters. Dowiedz się, jak zbieramy, wykorzystujemy i chronimy Twoje dane osobowe. Zgodność z RODO.'
    }
  },
  terms: {
    en: {
      title: 'Terms of Service | IT Monsters',
      description: 'IT Monsters Terms of Service. Read our terms and conditions for website development services.'
    },
    ru: {
      title: 'Условия использования | IT Monsters',
      description: 'Условия использования IT Monsters. Ознакомьтесь с условиями предоставления услуг по разработке сайтов.'
    },
    ua: {
      title: 'Умови використання | IT Monsters',
      description: 'Умови використання IT Monsters. Ознайомтеся з умовами надання послуг з розробки сайтів.'
    },
    pl: {
      title: 'Regulamin | IT Monsters',
      description: 'Regulamin IT Monsters. Przeczytaj nasze warunki świadczenia usług tworzenia stron internetowych.'
    }
  },
  thankYou: {
    en: {
      title: 'Thank You! | IT Monsters',
      description: 'Thank you for your inquiry. We will contact you shortly with your free website demo.'
    },
    ru: {
      title: 'Спасибо! | IT Monsters',
      description: 'Спасибо за вашу заявку. Мы свяжемся с вами в ближайшее время с бесплатным демо сайта.'
    },
    ua: {
      title: 'Дякуємо! | IT Monsters',
      description: "Дякуємо за вашу заявку. Ми зв'яжемося з вами найближчим часом з безкоштовним демо сайту."
    },
    pl: {
      title: 'Dziękujemy! | IT Monsters',
      description: 'Dziękujemy za zapytanie. Skontaktujemy się z Tobą wkrótce z darmowym projektem strony.'
    }
  },
  thankYouReferral: {
    en: {
      title: 'Welcome to Referral Program! | IT Monsters',
      description: 'Thank you for joining our referral program. We will send you your unique referral link shortly.'
    },
    ru: {
      title: 'Добро пожаловать в реферальную программу! | IT Monsters',
      description: 'Спасибо за присоединение к реферальной программе. Мы отправим вам уникальную реферальную ссылку.'
    },
    ua: {
      title: 'Ласкаво просимо до реферальної програми! | IT Monsters',
      description: 'Дякуємо за приєднання до реферальної програми. Ми надішлемо вам унікальне реферальне посилання.'
    },
    pl: {
      title: 'Witamy w Programie Partnerskim! | IT Monsters',
      description: 'Dziękujemy za dołączenie do naszego programu partnerskiego. Wkrótce prześlemy Twój unikalny link polecający.'
    }
  }
});
// URL paths for each page
const pagePaths: Record<string, string> = {
  home: '',
  referral: 'referral',
  privacy: 'privacy',
  terms: 'terms',
  thankYou: 'thank-you',
  thankYouReferral: 'thank-you-referral'
};
export function SEO({
  page = 'home'
}: SEOProps) {
  const {
    language
  } = useLanguage();
  useEffect(() => {
    const seoData = getSeoData();
    const pageData = seoData[page] || seoData.home;
    const currentMeta = pageData[language as Language] || pageData.pl;
    const pagePath = pagePaths[page] || '';
    // Update title
    document.title = currentMeta.title;
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', currentMeta.description);
    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    const baseUrl = 'https://itmonsters.agency';
    const langPrefix = language === 'pl' ? '' : `/${language}`;
    const canonicalUrl = `${baseUrl}${langPrefix}${pagePath ? `/${pagePath}` : ''}`;
    canonical.setAttribute('href', canonicalUrl);
    // Update hreflang tags
    const languages: Language[] = ['en', 'ru', 'ua', 'pl'];
    // Remove existing hreflang tags
    document.querySelectorAll('link[hreflang]').forEach(el => el.remove());
    // Add hreflang tags for all languages
    languages.forEach(lang => {
      const hreflang = document.createElement('link');
      hreflang.setAttribute('rel', 'alternate');
      hreflang.setAttribute('hreflang', lang === 'ua' ? 'uk' : lang);
      const langPrefixHref = lang === 'pl' ? '' : `/${lang}`;
      hreflang.setAttribute('href', `${baseUrl}${langPrefixHref}${pagePath ? `/${pagePath}` : ''}`);
      document.head.appendChild(hreflang);
    });
    // Add x-default hreflang
    const xDefault = document.createElement('link');
    xDefault.setAttribute('rel', 'alternate');
    xDefault.setAttribute('hreflang', 'x-default');
    xDefault.setAttribute('href', `${baseUrl}${pagePath ? `/${pagePath}` : ''}`);
    document.head.appendChild(xDefault);
    // Update Open Graph tags
    const ogTags = [{
      property: 'og:title',
      content: currentMeta.title
    }, {
      property: 'og:description',
      content: currentMeta.description
    }, {
      property: 'og:url',
      content: canonicalUrl
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:site_name',
      content: 'IT Monsters'
    }, {
      property: 'og:locale',
      content: language === 'en' ? 'en_US' : language === 'ru' ? 'ru_RU' : language === 'ua' ? 'uk_UA' : 'pl_PL'
    }];
    ogTags.forEach(({
      property,
      content
    }) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    });
    // Update Twitter Card tags
    const twitterTags = [{
      name: 'twitter:card',
      content: 'summary_large_image'
    }, {
      name: 'twitter:title',
      content: currentMeta.title
    }, {
      name: 'twitter:description',
      content: currentMeta.description
    }];
    twitterTags.forEach(({
      name,
      content
    }) => {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', name);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    });
    // Update html lang attribute
    document.documentElement.lang = language === 'ua' ? 'uk' : language;
  }, [language, page]);
  return null;
}